import React, { forwardRef, useImperativeHandle, useRef, useState, useEffect } from "react";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Stack, Button, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, Checkbox } from '@mui/material';
import Grid from '@mui/material/Grid2';
import 'moment/locale/th';
import moment from 'moment';
import {
    MDBListGroup, MDBListGroupItem, MDBBadge,
    MDBInput
    , MDBInputGroup
    , MDBRow, MDBCol
    , MDBIcon
    , MDBTextArea
    , MDBTimepicker
    , MDBDatepicker
    , MDBBtn
    , MDBAutocomplete
    , MDBCheckbox
}
    from 'mdb-react-ui-kit';
const Component = forwardRef((props, ref) => {

    const [status, setStatus] = useState(0);
    const filteritem = () => {

        if (props.items && props.setitems && props.duedate && props.status) {
            if (status == 4) {
                var filterd = props.items.filter(e => moment(e[props.duedate]) < moment() && e[props.status] != 3)
                props.setitems(filterd);
            }
            else if (status == 0) {

                props.setitems([...props.items]);
            }

            else {
                var filterd = props.items.filter(e => e[props.status] == status)
                props.setitems(filterd);
            }

        }


    };
    useEffect(() => {

        filteritem();

    }, [status, props.items]);

    return (<>





        <Stack
            direction="row" spacing={2}
            sx={{
                alignItems: "baseline",
            }}
        >
            <FormControl >
                <FormLabel id="demo-controlled-radio-buttons-group">สถานะ</FormLabel>
                <RadioGroup
                    row
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    sx={{
                        alignItems: "baseline",
                    }}
                ><FormControlLabel value="0" control={<Radio />} label="ทั้งหมด" />
                   {!props.hiddenopen && <FormControlLabel value="1" control={<Radio />} label="เปิด" />}
                    <FormControlLabel value="2" control={<Radio />} label="ยืนยัน" />
                    <FormControlLabel value="3" control={<Radio />} label="อนุมัติ" />
                    <FormControlLabel value="4" control={<Radio />} label="เกินกำหนดชำระ" />

                </RadioGroup>
            </FormControl>   </Stack>


    </>

    );
});



export default Component;